import {Component, OnInit, Output, Renderer, ViewChild, ElementRef, Input, forwardRef, OnDestroy} from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { FacilitiesService } from '../../../../facilities/facilities.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-auto-complete-facilities-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => SearchComponent),
      multi: true
    }
  ]
})
export class SearchComponent implements OnInit, ControlValueAccessor, OnDestroy {
  private observables: Subscription[] = [];
  private ld: any;
  protected state: boolean;
  protected facilities = [];
  isFocus: boolean;
  @Input()  inputDisabled= false;
  @Input()  clearAfterSearch = false;
  @Input()  search: any;
  @Input()  payor: any;
  @Output() emitterSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitterAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() addressFacility: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('inputSearch') input: ElementRef;

  propagateChange: any = () => {};
  constructor(private _facitities: FacilitiesService, private render: Renderer) {
    this.isFocus = false;
  }

  /**
   * @name onSearchChange
   * @param {string} value
   * @return {any}
   */
  onSearchChange(value: string): any {
    if (value) {
      this.observables.push(
        this._facitities
          .getFacilities(value, false, this.payor)
          .subscribe((data) => {
            this.facilities = data;
          }));
    }else {
      this.facilities = [];
    }
  }

  validateEmpty(value) {
    return value  ? value : '';
  }
  /**
   * @name selected
   * @description Seleccionar una opcion
   * @param {any} value
   */
  selected (value: any): any  {
    this.propagateChange(value.facilityid);
    this.loadFacility(value);
  }

  /**
   * @description
   * @param value
   */
  loadFacility(value) {
    const facility = {
      location                        : this.validateEmpty(value.description),
      locationName                    : this.validateEmpty(value.description),
      street_number                   : this.validateEmpty(value.streetaddress),
      streetaddress                   : this.validateEmpty(value.streetaddress),
      city                            : this.validateEmpty(value.city),
      state                           : this.validateEmpty(value.state),
      zip                             : this.validateEmpty(value.zip),
      roomaptnumber                   : this.validateEmpty(value.roomaptnumber),
      locality                        : this.validateEmpty(value.city),
      administrative_area_level_1     : this.validateEmpty(value.state),
      county                          : this.validateEmpty(value.county),
      postal_code                     : this.validateEmpty(value.zip),
      phonenumber                     : this.validateEmpty(value.phonenumber),
      latitude                        : this.validateEmpty(value.latitude),
      longitude                       : this.validateEmpty(value.longitude),
      modifierid                      : this.validateEmpty((value.facilitytype) ? value.facilitytype.modifierid : ''),
      facilityid                      : this.validateEmpty(value.facilityid),
    };
    this.search = value.description;
    this.focusOut();
    this.emitterSelected.emit(facility);
    // Realiza limpiado del control de acuerdo a lo especificado en el input clearAfterSearch
    if ( this.clearAfterSearch ) {
      this.search = '';
    }
  }

  /**
   * @description:
   * @param value
   */
  writeValue(value: any) {
    this.observables.push(
    this._facitities.getFacilityById(value).subscribe((data) => this.loadFacility(data) ));
  }

  /**
   * @description
   * @param fn
   */
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  /**
   * @description
   * @param {() => void} fn
   */
  registerOnTouched(fn: () => void): void {

  }
  /**
   * @description
   * @param {boolean} state
   */
  setDisabledState(state: boolean) {
    this.state = state;
  }

  /**
   * @name focusOut
   * @description Al salir del focus del input
   */
  focusOut () {
    setTimeout(() => {
      this.isFocus = false;
      this.emitterEvent();
    }, 300);
  }
  /**
   * @name
   * @description AL hacer focus la input
   */
  focus () {
    this.isFocus = true;
    this.emitterEvent();
  }
  /**
   * @name
   * @description al salir del focus o al seleccionar registro
   */
  emitterEvent() {
    this.emitterAction.emit({
      isFocus: this.isFocus,
      search: this.search
    });
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/auto-complete-facilities/components/search/search.component.ts